import React from "react";
import { IoClose } from "react-icons/io5";
import { IoDocumentOutline } from "react-icons/io5";
import { FaSave } from "react-icons/fa";
import { GiCrossMark } from "react-icons/gi";
import { IoPrintSharp } from "react-icons/io5";
import { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";
import Select from "react-select";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import vehicleMasterData from "../../../store/VehicleMasterERP";
const KmReadingAndValue = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sessiontoken = window.sessionStorage.getItem("session-token");
  const state = useSelector((state) => state.changeTheState);
  const user = state?.user?.emailId?.split("@")[0];
  const location = useLocation();
  const menu = location.state ? location.state.menu : null;
  const authToken = window.sessionStorage.getItem("auth-token");
 const BASEURL_GLOBAL =  process.env.REACT_APP_BASEURL_GLOBAL;
  const BASEURL = process.env.REACT_APP_BASEURL;
  const [isLoading, setIsLoading] = useState(true);
  const data = vehicleMasterData((state) => state.data);

  const [formData, setFormData] = useState({
    openingOdometerReading: "",
    openingOdometerDate: new Date().toISOString(),
    kmCoveredOpeningBalance: "",
    openingKMDate: new Date().toISOString(),
    assetValueAtBegining: "",
    beginingDate: new Date().toISOString(),
    currentAssetValue: "",
    trackingUnitNo: "",
    data: [],
  });

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  useEffect(() => {
    if (data?.OM_VEHICLE_REG_NO) {
      getData(data?.OM_VEHICLE_REG_NO);
    }
  }, [data]);

  const getData = (vehicle) => {
    axios
      .get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=1362&OM_VEHICLE_REG_NO=${encodeURIComponent(vehicle)}`,
        // `${BASEURL_GLOBAL}/globalViewHandler?viewname=1262`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      )
      .then((res) => {
        handleChange(
          "openingOdometerReading",
          res?.data[0]?.OM_VEHICLE_OPENING_ODOMETER_READING || "",
        );
        handleChange(
          "openingOdometerDate",
          res?.data[0]?.OM_VEHICLE_OPENING_ODOMETER_READING_DATE || "",
        );
        handleChange(
          "kmCoveredOpeningBalance",
          res?.data[0]?.OM_VEHICLE_OPENING_KM_READING || "",
        );
        handleChange(
          "openingKMDate",
          res?.data[0]?.OM_VEHICLE_OPENING_KM_READING_DATE || "",
        );
        handleChange(
          "assetValueAtBegining",
          res?.data[0]?.OM_VEHICLE_ASSET_VALUE || "",
        );
        handleChange(
          "beginingDate",
          res?.data[0]?.OM_VEHICLE_ASSET_VALUE_DATE || "",
        );
        handleChange(
          "currentAssetValue",
          res?.data[0]?.OM_VEHICLE_ASSET_VALUE_LATEST || "",
        );
      })
      .catch((err) => {
        console.log("Error While fetching 1262", err);
      });
  };

  return (
    <div className="text-xs">
      <div className="lg:flex lg:flex-col mt-3 justify-between bg-gray-100 p-2 m-2 rounded-md">
        {/* 1st Row  */}
        <div className="flex">
          <span className="lg:ml-2 w-[200px]">Opening Odometer Reading:</span>
          <input
            className="w-40 h-6  border border-black p-2 focus:outline-none focus:border-blue-500"
            type="text"
            value={formData?.openingOdometerReading}
            onChange={(e) =>
              handleChange("openingOdometerReading", e.target.value)
            }
          ></input>
          <span className="lg:ml-2 text-red-500 w-[600px]">
            This Value is 0 by default. When you reset your odometer, put all
            the Last Odometer reading in this field so that the values are
            carried forward
          </span>
        </div>
        {/* 2nd Row  */}
        <div className="flex">
          <span className="lg:ml-2 w-[200px]">Opening Odometer Date:</span>
          <input
            className="w-40 h-6  border border-black p-2 focus:outline-none focus:border-blue-500"
            type="date"
            value={formData?.openingOdometerDate?.split("T")[0]}
            onChange={(e) =>
              handleChange("openingOdometerDate", e.target.value)
            }
          ></input>
        </div>

        {/* 3rd Row  */}
        <div className="flex">
          <span className="lg:ml-2 w-[200px]">KM Covered Opening Balance:</span>
          <input
            className="w-40 h-6  border border-black p-2 focus:outline-none focus:border-blue-500"
            type="text"
            value={formData?.kmCoveredOpeningBalance}
            onChange={(e) =>
              handleChange("kmCoveredOpeningBalance", e.target.value)
            }
          ></input>
        </div>

        {/* 4th Row  */}
        <div className="flex">
          <span className="lg:ml-2 w-[200px]">Opening KM Date:</span>
          <input
            className="w-40 h-6  border border-black p-2 focus:outline-none focus:border-blue-500"
            type="date"
            value={formData?.openingKMDate?.split("T")[0]}
            onChange={(e) => handleChange("openingKMDate", e.target.value)}
          ></input>
        </div>

        {/* 5th Row */}
        <div className="flex flex-col mt-1 border-[2px] border-slate-400 p-1">
          <span className="text-sm text-red-500">Asset Value</span>

          <div className="flex flex-col">
            <div className="flex">
              <span className="lg:ml-2 w-[180px]">
                Asset Value at Begining:
              </span>
              <input
                className="w-40 h-6  border border-black p-2 focus:outline-none focus:border-blue-500 mr-20"
                type="text"
                value={formData?.assetValueAtBegining}
                onChange={(e) =>
                  handleChange("assetValueAtBegining", e.target.value)
                }
              ></input>
              <button className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]">
                Update
              </button>
            </div>
            <div className="flex">
              <span className="lg:ml-2 w-[180px]">Begining Date:</span>
              <input
                className="w-40 h-6  border border-black p-2 focus:outline-none focus:border-blue-500"
                type="date"
                value={formData?.beginingDate?.split("T")[0]}
                onChange={(e) => handleChange("beginingDate", e.target.value)}
              ></input>
            </div>
            <div className="flex">
              <span className="lg:ml-2 w-[180px]">Current Asset Value:</span>
              <input
                className="w-40 h-6  border border-black p-2 focus:outline-none focus:border-blue-500"
                type="text"
                value={formData?.currentAssetValue}
                onChange={(e) =>
                  handleChange("currentAssetValue", e.target.value)
                }
              ></input>
            </div>
          </div>
        </div>

        {/* 6th Row  */}
        <div className="flex">
          <span className="lg:ml-2 w-[185px]">Tracking Unit No:</span>
          <input
            className="w-40 h-6  border border-black p-2 focus:outline-none focus:border-blue-500"
            type="text"
            value={formData?.trackingUnitNo}
            onChange={(e) => handleChange("trackingUnitNo", e.target.value)}
          ></input>
        </div>
      </div>
    </div>
  );
};

export default KmReadingAndValue;
